import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconInbox = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M4.05078 2.7998H13.9492C14.5681 2.7998 15.0861 3.27062 15.1445 3.88672L15.9961 12.8867C16.0628 13.591 15.5092 14.2002 14.8018 14.2002H3.19824C2.49084 14.2002 1.93723 13.591 2.00391 12.8867L2.85547 3.88672C2.91388 3.27062 3.43191 2.7998 4.05078 2.7998Z",
		stroke: "currentColor",
		strokeWidth: 1.6
	}), /* @__PURE__ */ _jsx("path", {
		d: "M3 9.19995H6L6.5 11.2H9H11.5L12 9.19995H15",
		stroke: "currentColor",
		strokeWidth: 1.6,
		strokeLinecap: "round"
	})]
});
export default SvgIconInbox;
